import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { mspApi } from '../services/api';
import './msp/Msp.css';

function ExternalScansOverview() {
  const [tenants, setTenants] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    mspApi
      .listTenants()
      .then((response) => {
        const list = Array.isArray(response.data) ? response.data : response.data?.tenants || [];
        setTenants(list);
        setStatus('ready');
      })
      .catch((err) => {
        console.error('Failed to load tenants for external scans overview', err);
        setStatus('error');
      });
  }, []);

  const riskColor = (score) => {
    if (score >= 7) return 'var(--danger, #e74c3c)';
    if (score >= 4) return 'var(--warning, #f39c12)';
    return 'var(--success, #27ae60)';
  };

  const statusBadge = (scanStatus) => {
    const map = {
      completed: { label: 'Completed', cls: 'status-completed' },
      running: { label: 'Running', cls: 'status-running' },
      failed: { label: 'Failed', cls: 'status-failed' },
      pending: { label: 'Pending', cls: 'status-pending' },
      not_started: { label: 'Not Started', cls: '' },
    };
    const info = map[scanStatus] || { label: scanStatus || 'Unknown', cls: '' };
    return <span className={`status-badge ${info.cls}`}>{info.label}</span>;
  };

  return (
    <div className="msp-page">
      <div className="msp-header">
        <div>
          <h1>External Scans</h1>
          <p className="msp-subtitle">
            External attack surface scans across all tenants
          </p>
        </div>
      </div>

      {status === 'loading' && <div className="msp-empty">Loading tenants…</div>}
      {status === 'error' && <div className="msp-empty">Unable to load tenants.</div>}

      {status === 'ready' && tenants.length === 0 && (
        <div className="msp-empty">
          No tenants found.{' '}
          <Link to="/msp/tenants">Create a tenant</Link> to get started with external scanning.
        </div>
      )}

      {status === 'ready' && tenants.length > 0 && (
        <table className="msp-table">
          <thead>
            <tr>
              <th>Tenant</th>
              <th>Domain</th>
              <th>Last Scan</th>
              <th>Status</th>
              <th>Exposures</th>
              <th>Open Ports</th>
              <th>Risk</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tenants.map((t) => (
              <tr key={t.id}>
                <td>
                  <Link to={`/msp/tenants/${t.id}`} style={{ fontWeight: 600 }}>
                    {t.name}
                  </Link>
                </td>
                <td style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                  {t.primary_domain || '—'}
                </td>
                <td style={{ fontSize: '13px' }}>
                  {t.last_scan_at
                    ? new Date(t.last_scan_at).toLocaleString()
                    : '—'}
                </td>
                <td>{statusBadge(t.scan_status)}</td>
                <td>{t.total_exposures ?? '—'}</td>
                <td>
                  {typeof t.open_ports === 'number'
                    ? `${t.open_ports} / ${t.ports_scanned || 0}`
                    : '—'}
                </td>
                <td>
                  <span style={{ color: riskColor(t.risk_score || 0), fontWeight: 600 }}>
                    {typeof t.risk_score === 'number' ? t.risk_score.toFixed(1) : '—'}
                  </span>
                </td>
                <td>
                  <Link
                    to={`/msp/tenants/${t.id}/external-scans`}
                    className="btn btn-secondary"
                    style={{ padding: '6px 14px', fontSize: '12px' }}
                  >
                    View Scans
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ExternalScansOverview;
